// Custom lazyload iframe element
if ('IntersectionObserver' in window) { // Detect support for IntersectionObserver
  const lazyloadIframe = '.js-lazyload-iframe' // Define observed targets
  const targets = document.querySelectorAll(lazyloadIframe)
  // Observer
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { // Deal with every intersection
        entry.target.src = entry.target.dataset.src // Swap in the iframe src
        entry.target.dataset.loaded = true // Declare this was loaded...
        entry.target.removeAttribute('data-src') // Remove data-src (for the sake of clarity)
        observer.unobserve(entry.target) // Remove observer if intersection took place, so this is carried out only once per iframe
      }
    })
  })
  // Observe targets
  targets.forEach(target => {
    observer.observe(target)
  })
}
